import {Breadcrumbs, Link} from '@material-ui/core'
import usePrefix from 'modules/reports/hooks/prefix'
import React, {MouseEventHandler} from 'react'
import useStyles from './ReportsBreadcrumbs.styles'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'

export type Breadcrumb = {label: string; href?: string; onClick?: MouseEventHandler<any>}

type Props = {
  breadcrumbs: Breadcrumb[]
  'data-testid': string
}

function ReportsBreadcrumbs(props: Props) {
  const classes = useStyles()
  const p = usePrefix(props['data-testid'])

  function renderBreadcrumb(breadcrumb: Breadcrumb, index: number) {
    const isLast = index === props.breadcrumbs.length - 1

    return (
      <Link
        key={index}
        component={isLast ? 'span' : 'a'}
        href={breadcrumb.href}
        onClick={breadcrumb.onClick}
        data-testid={p(`item-${index}`)}
        color={isLast ? 'textPrimary' : 'inherit'}
        underline={isLast ? 'none' : 'hover'}
      >
        {breadcrumb.label}
      </Link>
    )
  }

  return (
    <Breadcrumbs
      className={classes.root}
      separator={<NavigateNextIcon fontSize="small" />}
      data-testid={p()}
      aria-label="breadcrumb"
    >
      {props.breadcrumbs.map((breadcrumb, index) => renderBreadcrumb(breadcrumb, index))}
    </Breadcrumbs>
  )
}

export default ReportsBreadcrumbs
